import { Quill } from 'react-quill';

const Parchment = Quill.import('parchment');
const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);
const pixelLevels: number[] = [1, 2, 3];
const TAB_MULTIPLIER = 20;
export class IndentAttributor extends (Parchment.Attributor.Style as {
  new (formatName: unknown, styleProperty: unknown, attributorOptions: unknown);
}) {
  constructor(formatName: unknown, styleProperty: unknown, attributorOptions: unknown) {
    super(formatName, styleProperty, attributorOptions);
  }

  public add(node: HTMLElement, value: string): boolean {
    return super.add(node, `${+value * TAB_MULTIPLIER}px`);
  }

  public value(node: HTMLElement): number | undefined {
    return parseFloat(super.value(node)) / TAB_MULTIPLIER || undefined;
  }
}

export const IndentStyle = new IndentAttributor('indent', 'margin-left', {
  scope: Parchment.Scope.BLOCK,
  whitelist: pixelLevels.map((value) => `${value * TAB_MULTIPLIER}px`),
});

Quill.register(IndentStyle, true);
